"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { PATH } from "@/constants/path";
import { useBatchImpressionTracking } from "@/hooks/useImpressionTracking";
import { trackEvent } from "@/utils/analytics";
import { cn } from "@/utils/cn";
import Button from "./Button";

interface CTASectionProps {
  className?: string;
}

function CTASection({ className }: CTASectionProps) {
  const path = usePathname();

  const impressionEvents = useMemo(
    () => [
      { eventName: "cta_impression", params: { cta_type: "inquiry", cta_position: "bottom_cta" } },
      { eventName: "download_btn_impression", params: { file_name: "company_deck", cta_position: "bottom_cta" } },
    ],
    [],
  );

  const sectionRef = useBatchImpressionTracking<HTMLElement>(impressionEvents);

  const handleContactClick = () => {
    trackEvent("cta_click", path, { cta_type: "inquiry", cta_position: "bottom_cta" });
  };

  const handleDownloadClick = () => {
    trackEvent("file_download", path, { file_name: "company_deck", cta_position: "bottom_cta" });
  };

  return (
    <section ref={sectionRef} className={cn("flex items-center justify-center bg-footer px-side py-32", className)}>
      <div className="flex flex-col items-center gap-10">
        <div className="text-center text-30 font-semibold">
          <span className="whitespace-nowrap">우리 기업에</span> <span className="whitespace-nowrap">꼭 필요한 핵심 인재,</span>{" "}
          <br className="hidden tablet:block" />
          <span className="whitespace-nowrap">숨어있던 인재들을</span>{" "}
          <span className="whitespace-nowrap">지금 바로 만나보세요.</span>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          <Button href={PATH.REQUEST} onClick={handleContactClick}>
            24시간 내 채용 진단 받기
          </Button>
          <Button color="gray" href={PATH.COMPANY_INTRO} target="_blank" rel="noopener noreferrer" onClick={handleDownloadClick}>
            회사 소개서 다운받기
          </Button>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
